import { render, staticRenderFns } from "./WorkOrder.vue?vue&type=template&id=2e8af4b4&scoped=true&"
import script from "./WorkOrder.vue?vue&type=script&lang=js&"
export * from "./WorkOrder.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrder.vue?vue&type=style&index=0&id=2e8af4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8af4b4",
  null
  
)

export default component.exports